import { Controller } from "@hotwired/stimulus";
import { getConsumerFor } from "../channels/consumer";
import type { Subscription } from "@rails/actioncable";

interface VoterGroupImporterProgress {
  workflow_state: string;
  progress_current: number;
  progress_total: number;
}

export default class extends Controller {
  static values = {
    id: Number,
    workflowState: String,
  };

  static targets = ["bar"];

  declare readonly idValue: number;
  declare readonly workflowStateValue: string;
  declare readonly barTarget: HTMLElement;
  declare readonly hasBarTarget: boolean;

  private subscription?: Subscription;

  connect() {
    this.subscription = getConsumerFor(null).subscriptions.create(
      { channel: "VoterGroupImporterChannel", id: this.idValue },
      { received: (data: VoterGroupImporterProgress) => this.received(data) }
    );
  }

  disconnect() {
    this.subscription?.unsubscribe();
  }

  received(data: VoterGroupImporterProgress) {
    if (this.hasBarTarget && data.progress_total > 0) {
      const percentage = Math.round((100 * data.progress_current) / data.progress_total);
      this.barTarget.style.width = `${percentage}%`;
      this.barTarget.setAttribute("aria-valuenow", String(data.progress_current));
      this.barTarget.textContent = `${data.progress_current}/${data.progress_total}`;
    }

    if (data.workflow_state !== this.workflowStateValue) {
      // Small delay so the user can see the progress bar reach 100% before the page reloads.
      setTimeout(() => window.location.reload(), 500);
    }
  }
}
